import numeral from 'numeral';
import { FIXED_ODD_STATUS } from 'Store/constants/horseRacing';
import EnvironmentManager from 'Utils/environmentManager';

numeral.register('locale', 'tr', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  currency: {
    symbol: '₺'
  }
});

numeral.locale('tr');

export const decimalFormatter = value => {
  if (+value % 1 != 0) {
    return doubleDigitDecimalFormatter(value);
  } else {
    return numeral(+value).format('0,0');
  }
};

export const decimalFormatterLast = value => {
  if (+value % 1 != 0) {
    return doubleDigitDecimalFormatter(value);
  } else {
    return numeral(+value).format('0,0.00');
  }
};

export const doubleDigitDecimalFormatter = value => {
  return numeral(+value).format('0,0.00');
};

export const thousandFormatter = value => {
  return numeral(+value).format('0,0');
};

export const oddFormatter = value => {
  if (typeof value === 'object') {
    if (value?.spbah) return 'K.O';
    return (Math.round(value?.odd * 100) / 100).toFixed(2);
  } else {
    return (Math.round(value * 100) / 100).toFixed(2);
  }
};

export const isOddLocked = status => {
  return ![FIXED_ODD_STATUS.OPEN, FIXED_ODD_STATUS.EACHWAY].includes(status);
};

export const horseMessage = status => {
  if (!status) return null;
  if ([FIXED_ODD_STATUS.SUSPENDED, FIXED_ODD_STATUS.LATE_SCRATCH, FIXED_ODD_STATUS.EARLY_SCRATCH].includes(status)) {
    return EnvironmentManager.getMessageText({ key: 'v1.bulletin_fixodd.odd_status.' + status });
  }
  return null;
};
export const createAmountChangeHandler = (setter, maxLength = 7) => e => {
  const value = e.target.value.replace(/\./g, '').replace(/\D/g, '');
  if (value.length <= maxLength) {
    setter(value);
  }
};

export const createDecimalChangeHandler = (setter, maxLength = 2) => e => {
  const value = e.target.value.replace(/\D/g, '');
  if (value.length <= maxLength) {
    setter(value);
  }
};
